import { Button } from "antd";

import PriceTag from "../../assets/images/price-tag.svg"
import { PriceInformationIconContainer, PriceInformationIconImage, PriceInformationMain, PriceInformationMessage, PriceInformationTitle } from "./styles";
import { StyledButton } from "../CustomAntdComponents/StyledButton";

const SearchPriceNotification = ({onClick}: any) => {
  return (
    <PriceInformationMain>
        <PriceInformationIconContainer>
          <PriceInformationIconImage src={PriceTag} alt="price tag" />
        </PriceInformationIconContainer>
        
        <PriceInformationTitle>
          The price you see is the price you pay
        </PriceInformationTitle>
        <PriceInformationMessage>
          No surprises at checkout. We include all fees upfront
        </PriceInformationMessage>
  
        <StyledButton style={{width: "100%"}} mode="primary" onClick={onClick}>Got it </StyledButton>
      </PriceInformationMain>
  )
}

export default SearchPriceNotification;